/**  Returns a date object that is cearted based on the time in Sweden
 * PLEASE NOTE: getSwedishDateToday().toString() will still include the timezone
 * getSwedishDateToday().toISOString() will return an "agnostic" tiemstamp.
 */
export const getSwedishDateToday = (): Date => {
  return new Date(new Date().toLocaleString('sv-SE', { timeZone: 'Europe/Stockholm' }).slice(0, 10));
};
